import React from 'react';
import PropTypes from 'prop-types';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { StepConnector } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function DesktopStepper({ activeStep, steps }) {
  const classes = useStyles();

  return (
    <Stepper data-testid="stepper" orientation="vertical" className={classes.stepper} activeStep={activeStep} connector={<StepConnector className={classes.connector} />}>
      {steps.map((label) => (
        <Step key={label}>
          <StepLabel
            StepIconProps={{
              classes: {
                root: classes.step,
              },
            }}
            className={classes.label}
          >
            {label}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
}

DesktopStepper.propTypes = {
  activeStep: PropTypes.number.isRequired,
  steps: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default DesktopStepper;
